const Events = () => {
    return (
      <div>
        <h1>Events</h1>
        {/* Content goes here */}
      </div>
    );
};

export default Events;